<template>
    <div>
        <span style="font-size: 2rem; font-weight: 500;">{{client_step_data.step_name}}</span>
        <b-card>
            <!-- //* WIZARD START -->
            <b-overlay :show="isSaving" variant="success">
                <form-wizard shape="square" ref="step-wizard" @on-change="onChange" @on-complete="onComplete" color="#556ee6">
                    <tab-content :lazy="true" :before-change="tabChange" v-for="view in client_step_data.spreadify_views" :key="view.id" :icon="`mdi mdi-numeric-${view.render_order}-box-multiple`">
                            <form-plugin :admin="true" :viewFile="clientMediaFile(view.spreadify_uid)" :step="view.render_order" @downloadFile=processFileDownload @uploaderData="processUpload" @formDataUpdated="updateFormData" :viewData="view.form_data" :uid="view.spreadify_uid"></form-plugin>
                    </tab-content>
                </form-wizard>
            </b-overlay>
            <!-- //* WIZARD END -->
        </b-card>
        <DownloadModal v-if="showDownloadModal" />
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import Uploader from 'simple-uploader.js'

import _ from 'lodash'

import DownloadModal from '@/components/client/downloadModal'

import { ccbAdminState, ccbAdminMethods, licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    components: { FormWizard, TabContent, DownloadModal },
    data:() => ({
        showDownloadModal: false,
        isSaving: false,
        hasSaved: false,
        current_form_data: [],
        params:{},
    }),
    computed:{
        ...ccbAdminState,
        ...licenseAppState,
    },
    methods:{
        ...licenseAppMethods,
        ...ccbAdminMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            let step_index = _.findIndex(this.client_step_data.spreadify_views, {spreadify_uid: newData.uid})
            if(step_index > -1){
                let view = this.client_step_data.spreadify_views[step_index];
                let index = view.render_order - 1;
                this.current_form_data[index] = newData.data;
            }
        },

        clientMediaFile(uid){
            let files = [];
            this.client_step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },

        processUpload(file){
            //* Uploader event method
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/licenseapp/uploadmedia',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{
                    step_id : 2,
                    spreadify_uid : '612f6171f003b',
                    key : 'document_file',
                },
                testChunks: false,
                fileParameterName: 'file', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                console.log('fileComplete')
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                console.log('fileAdded', file);
            });

            this.$nextTick(()=>{
                uploader.addFile(file);
                this.$nextTick(()=>{
                    uploader.upload();
                })
            });
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },

        //eslint-disable-next-line
        onChange(previous, next){
            //alert(`From ${previous} to ${next}`);
        },
        onComplete(){
            /*this.isSaving = true;
            this.params.form_data = this.params.form_data.filter(Boolean);

            this.saveFormData(this.params)
            .then(()=>{
                this.isSaving = false;
                this.requestStepApproval(this.client_step_data.id)
                .then(()=>{
                    //alert('Finished Step');
                    this.$emit('back', this.client_step_data.id);
                })
                .catch(()=>{ console.log('Error submitting final form')})
            })
            .catch(()=>{
                setTimeout(()=>{
                    this.isSaving = false;
                    alert('Approval Request Error');
                }, 500)
            })
            */
        },
        tabChange(){
            //let step = this.$refs['step-wizard'].activeTabIndex;
            //let isValid = this.validateStep(step);
            //alert(isValid)

            //* Admin mode, allow next
            return true;
        },

        //eslint-disable-next-line
        validateStep(step){
            this.current_form_data.forEach((item, index) => {
                this.params.form_data[index] = {
                    spreadify_uid: this.client_step_data.spreadify_views[index].spreadify_uid,
                    form_data:[],
                }
                for(const key in item){
                    this.params.form_data[index].form_data.push({key: key, value: item[key]})
                }
            });

            this.params.form_data = this.params.form_data.filter(Boolean);
            this.saveFormData(this.params);
            this.hasSaved = true;
            return true;
        },
    },
    mounted(){
        this.params = {
            step_id: this.client_step_data.id,
            form_data:[],
        }

        //* Activate all steps
        this.$refs['step-wizard'].activateAll();
    },
    beforeDestroy(){
        //*Fetch new data for the status bar and project timeline table
        if(this.hasSaved){
            this.loadAppData();
        }
    }
}
</script>

<style>
.input-label{
    font-weight: 600;
    font-size: 1rem;
}
.checkbox{
    margin-left: 0.5rem;
}
</style>